module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/parts/b-text/b-text.component.css
// module id = ./src/app/parts/b-text/b-text.component.css
// module chunks = main